import styled from 'styled-components';

export const Container = styled.div<{ showPassengerInfo: boolean }>`
  min-height: 6rem;
  background: ${({ theme: { colors }, showPassengerInfo }) =>
    showPassengerInfo
      ? `linear-gradient(to right, ${colors.b2cGrey} 70%, ${colors.b2cDarkBlack} 30%)`
      : `linear-gradient(to right, ${colors.b2cGrey} 70%, ${colors.b2cDarkGrey} 30%)`};
  display: flex;
  width: calc(100% - 3.2rem);
  padding: 0 1.6rem;
  color: ${({ theme: { colors } }) => colors.white};
  font-style: normal;
  margin: 0;
  word-wrap: break-word;
`;

export const BaseWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const PickUpWrapper = styled(BaseWrapper)<{
  showPassengerInfo: boolean;
}>`
  width: 35%;
  width: ${({ showPassengerInfo }) =>
    showPassengerInfo ? 'calc(45% - 3.2rem)' : '45%'};

  p {
    width: 100%;
  }
`;

export const DropOffWrapper = styled(BaseWrapper)<{
  showPassengerInfo: boolean;
}>`
  width: 45%;
  width: ${({ showPassengerInfo }) =>
    showPassengerInfo ? 'calc(55% - 3.2rem)' : '55%'};
  background-color: ${({ theme: { colors } }) => colors.b2cDarkGrey};
  -webkit-clip-path: polygon(
    3rem 0,
    100% 0%,
    ${({ showPassengerInfo }) =>
        showPassengerInfo ? 'calc(100% - 3rem)' : '100%'}
      100%,
    0 100%
  );
  clip-path: polygon(
    3rem 0,
    100% 0%,
    ${({ showPassengerInfo }) =>
        showPassengerInfo ? 'calc(100% - 3rem)' : '100%'}
      100%,
    0 100%
  );

  ${({ showPassengerInfo }) => {
    if (showPassengerInfo) {
      return `
        text-align: left;
        padding-left: 4rem;
      `;
    }

    return `
      text-align: right;
      padding-right: 1.6rem;
    `;
  }}

  p {
    width: ${({ showPassengerInfo }) => (showPassengerInfo ? '80%' : '100%')};
  }
`;

export const PassengerInfoWrapper = styled(BaseWrapper)`
  text-align: center;
  background-color: ${({ theme: { colors } }) => colors.b2cDarkBlack};
  justify-content: center;
`;

export const PassengerInfoContainer = styled.div`
  height: 2.4rem;
  display: flex;
  justify-content: center;
`;

export const PassengerInfoSpan = styled.span`
  align-self: center;
  font-size: 1.28rem;
  line-height: 1.8rem;
  padding-left: 0.4rem;
`;

export const DateStyled = styled.p`
  font-weight: 600;
  font-size: 1.6rem;
  line-height: 2.4rem;
  margin: 0;
  padding-top: 1rem;
`;

export const LocationStyled = styled.p`
  font-weight: 400;
  font-size: 1.28rem;
  line-height: 1.8rem;
  margin: 0;
  padding-bottom: 1rem;
`;
